module.exports = __webpack_public_path__ + "resources/img/img_tibero4_m.c32601c62d73041fa58e4f56b43880fa.png";